import { Accordion, type AccordionProps } from "@mui/material";
import styled from "styled-components";

export const MUIAccordion: React.FC<AccordionProps> = ({ children, ...rest }) => (
  <StyledAccordion
    slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}
    disableGutters
    elevation={0}
    data-testid="accordion-item"
    {...rest}
  >
    {children}
  </StyledAccordion>
);

const StyledAccordion = styled(Accordion)`
  background-color: white !important;
  border: 1px solid ${props => props.theme.colors.greys.silver};
  &:not(:last-child) {
    border-bottom: 0;
  }
  &::before {
    display: none;
  }
`;
